module.exports = __webpack_public_path__ + "img/zdrugren.fd2cf96a.png";